import { render, staticRenderFns } from "./DettaglioImpianto.vue?vue&type=template&id=12c776f8&"
import script from "./DettaglioImpianto.vue?vue&type=script&lang=js&"
export * from "./DettaglioImpianto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports